import { UniversalCookieAdapter } from '@/infra/cache'
import Cookies from 'universal-cookie'

const universalCookies = new Cookies()

export const makeUniversalCookieAdapter = (): UniversalCookieAdapter => new UniversalCookieAdapter(universalCookies)
